module.exports = __webpack_public_path__ + "img/4.ba6777e8.jpg";